import React from 'react';

import { BaseIconProps } from './';

export const Phone = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.1176327,0,0,-2.1176327,0.0036615,1084.2279)"
    d="M 103,291 C 144,211 209,145 290,104 l 62,63 c 8,7 19,10 29,6 32,-10 66,-16 101,-16 16,0 28,-13 28,-28 V 30 C 510,14 498,2 482,2 216,1 0,217 0,483 c 0,0 0,0 0,1 0,15 13,28 28,28 h 100 c 15,0 28,-13 28,-28 0,-36 6,-70 16,-102 3,-10 1,-21 -7,-28 z"
    fill={fill}
  />
);
